<template>
  <div class="w-full d-flex flex-column pa-3">
    <OAlert class="w-full" info v-if="value.assocs.length < 1">
      Não existem usuários com este perfil.
    </OAlert>

    <v-simple-table v-else>
      <template v-slot:default>
        <tbody>
          <tr>
            <th class="text-right">ID</th>
            <th>Login</th>
            <th>Nome</th>
            <th>Associado em</th>
          </tr>
          <tr v-for="(item, idx) in value.assocs" :key="idx">
            <td class="text-right grey--text">{{ item.id }}</td>
            <td>{{ item.login }}</td>
            <td>{{ item.name }}</td>
            <td>
              {{ item.UserToProfile.createdAt | moment('YYYY-MM-DD HH:mm') }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <div class="pa-3">
      Para associar usuários a este perfil, edite um usuário por vez, usando a
      aba "Perfil".
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { required: true }
  }
}
</script>
